// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file yatayat/auth/v1/auth.proto (package yatayat.auth.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_yatayat_auth_v1_access } from "./access_pb";
import type { LocalizedName } from "../../types/v1/types_pb";
import { file_yatayat_types_v1_types } from "../../types/v1/types_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file yatayat/auth/v1/auth.proto.
 */
export const file_yatayat_auth_v1_auth: GenFile = /*@__PURE__*/
  fileDesc("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", [file_yatayat_auth_v1_access, file_yatayat_types_v1_types]);

/**
 * @generated from message yatayat.auth.v1.Session
 */
export type Session = Message<"yatayat.auth.v1.Session"> & {
  /**
   * @generated from field: string phone_masked = 1;
   */
  phoneMasked: string;

  /**
   * @generated from field: int64 expires_at_ms = 2;
   */
  expiresAtMs: bigint;
};

/**
 * Describes the message yatayat.auth.v1.Session.
 * Use `create(SessionSchema)` to create a new message.
 */
export const SessionSchema: GenMessage<Session> = /*@__PURE__*/
  messageDesc(file_yatayat_auth_v1_auth, 0);

/**
 * @generated from message yatayat.auth.v1.StartPhoneSignInRequest
 */
export type StartPhoneSignInRequest = Message<"yatayat.auth.v1.StartPhoneSignInRequest"> & {
  /**
   * Nepali mobile number: 98XXXXXXXX, 97…, 96…, optionally with +977.
   *
   * @generated from field: string phone = 1;
   */
  phone: string;
};

/**
 * Describes the message yatayat.auth.v1.StartPhoneSignInRequest.
 * Use `create(StartPhoneSignInRequestSchema)` to create a new message.
 */
export const StartPhoneSignInRequestSchema: GenMessage<StartPhoneSignInRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_auth_v1_auth, 1);

/**
 * @generated from message yatayat.auth.v1.StartPhoneSignInResponse
 */
export type StartPhoneSignInResponse = Message<"yatayat.auth.v1.StartPhoneSignInResponse"> & {
  /**
   * @generated from field: string challenge_id = 1;
   */
  challengeId: string;

  /**
   * @generated from field: int64 expires_at_ms = 2;
   */
  expiresAtMs: bigint;
};

/**
 * Describes the message yatayat.auth.v1.StartPhoneSignInResponse.
 * Use `create(StartPhoneSignInResponseSchema)` to create a new message.
 */
export const StartPhoneSignInResponseSchema: GenMessage<StartPhoneSignInResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_auth_v1_auth, 2);

/**
 * @generated from message yatayat.auth.v1.CompletePhoneSignInRequest
 */
export type CompletePhoneSignInRequest = Message<"yatayat.auth.v1.CompletePhoneSignInRequest"> & {
  /**
   * @generated from field: string challenge_id = 1;
   */
  challengeId: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;
};

/**
 * Describes the message yatayat.auth.v1.CompletePhoneSignInRequest.
 * Use `create(CompletePhoneSignInRequestSchema)` to create a new message.
 */
export const CompletePhoneSignInRequestSchema: GenMessage<CompletePhoneSignInRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_auth_v1_auth, 3);

/**
 * @generated from message yatayat.auth.v1.CompletePhoneSignInResponse
 */
export type CompletePhoneSignInResponse = Message<"yatayat.auth.v1.CompletePhoneSignInResponse"> & {
  /**
   * @generated from field: yatayat.auth.v1.Session session = 1;
   */
  session?: Session | undefined;
};

/**
 * Describes the message yatayat.auth.v1.CompletePhoneSignInResponse.
 * Use `create(CompletePhoneSignInResponseSchema)` to create a new message.
 */
export const CompletePhoneSignInResponseSchema: GenMessage<CompletePhoneSignInResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_auth_v1_auth, 4);

/**
 * @generated from message yatayat.auth.v1.GetSessionRequest
 */
export type GetSessionRequest = Message<"yatayat.auth.v1.GetSessionRequest"> & {
};

/**
 * Describes the message yatayat.auth.v1.GetSessionRequest.
 * Use `create(GetSessionRequestSchema)` to create a new message.
 */
export const GetSessionRequestSchema: GenMessage<GetSessionRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_auth_v1_auth, 5);

/**
 * @generated from message yatayat.auth.v1.GetSessionResponse
 */
export type GetSessionResponse = Message<"yatayat.auth.v1.GetSessionResponse"> & {
  /**
   * Unset when signed out.
   *
   * @generated from field: yatayat.auth.v1.Session session = 1;
   */
  session?: Session | undefined;
};

/**
 * Describes the message yatayat.auth.v1.GetSessionResponse.
 * Use `create(GetSessionResponseSchema)` to create a new message.
 */
export const GetSessionResponseSchema: GenMessage<GetSessionResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_auth_v1_auth, 6);

/**
 * @generated from message yatayat.auth.v1.SignOutRequest
 */
export type SignOutRequest = Message<"yatayat.auth.v1.SignOutRequest"> & {
};

/**
 * Describes the message yatayat.auth.v1.SignOutRequest.
 * Use `create(SignOutRequestSchema)` to create a new message.
 */
export const SignOutRequestSchema: GenMessage<SignOutRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_auth_v1_auth, 7);

/**
 * @generated from message yatayat.auth.v1.SignOutResponse
 */
export type SignOutResponse = Message<"yatayat.auth.v1.SignOutResponse"> & {
};

/**
 * Describes the message yatayat.auth.v1.SignOutResponse.
 * Use `create(SignOutResponseSchema)` to create a new message.
 */
export const SignOutResponseSchema: GenMessage<SignOutResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_auth_v1_auth, 8);

/**
 * @generated from message yatayat.auth.v1.StaffSession
 */
export type StaffSession = Message<"yatayat.auth.v1.StaffSession"> & {
  /**
   * @generated from field: string staff_id = 1;
   */
  staffId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: yatayat.auth.v1.StaffRole role = 3;
   */
  role: StaffRole;

  /**
   * Set for operator staff: the operator they act for.
   *
   * @generated from field: string operator_id = 4;
   */
  operatorId: string;

  /**
   * @generated from field: yatayat.types.v1.LocalizedName operator_name = 5;
   */
  operatorName?: LocalizedName | undefined;

  /**
   * Set for regulator staff: the authority they act for.
   *
   * @generated from field: string authority_id = 6;
   */
  authorityId: string;

  /**
   * @generated from field: string phone_masked = 7;
   */
  phoneMasked: string;

  /**
   * @generated from field: int64 expires_at_ms = 8;
   */
  expiresAtMs: bigint;
};

/**
 * Describes the message yatayat.auth.v1.StaffSession.
 * Use `create(StaffSessionSchema)` to create a new message.
 */
export const StaffSessionSchema: GenMessage<StaffSession> = /*@__PURE__*/
  messageDesc(file_yatayat_auth_v1_auth, 9);

/**
 * @generated from message yatayat.auth.v1.StartStaffSignInRequest
 */
export type StartStaffSignInRequest = Message<"yatayat.auth.v1.StartStaffSignInRequest"> & {
  /**
   * @generated from field: string phone = 1;
   */
  phone: string;
};

/**
 * Describes the message yatayat.auth.v1.StartStaffSignInRequest.
 * Use `create(StartStaffSignInRequestSchema)` to create a new message.
 */
export const StartStaffSignInRequestSchema: GenMessage<StartStaffSignInRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_auth_v1_auth, 10);

/**
 * @generated from message yatayat.auth.v1.StartStaffSignInResponse
 */
export type StartStaffSignInResponse = Message<"yatayat.auth.v1.StartStaffSignInResponse"> & {
  /**
   * @generated from field: string challenge_id = 1;
   */
  challengeId: string;

  /**
   * @generated from field: int64 expires_at_ms = 2;
   */
  expiresAtMs: bigint;
};

/**
 * Describes the message yatayat.auth.v1.StartStaffSignInResponse.
 * Use `create(StartStaffSignInResponseSchema)` to create a new message.
 */
export const StartStaffSignInResponseSchema: GenMessage<StartStaffSignInResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_auth_v1_auth, 11);

/**
 * @generated from message yatayat.auth.v1.CompleteStaffSignInRequest
 */
export type CompleteStaffSignInRequest = Message<"yatayat.auth.v1.CompleteStaffSignInRequest"> & {
  /**
   * @generated from field: string challenge_id = 1;
   */
  challengeId: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;
};

/**
 * Describes the message yatayat.auth.v1.CompleteStaffSignInRequest.
 * Use `create(CompleteStaffSignInRequestSchema)` to create a new message.
 */
export const CompleteStaffSignInRequestSchema: GenMessage<CompleteStaffSignInRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_auth_v1_auth, 12);

/**
 * @generated from message yatayat.auth.v1.CompleteStaffSignInResponse
 */
export type CompleteStaffSignInResponse = Message<"yatayat.auth.v1.CompleteStaffSignInResponse"> & {
  /**
   * @generated from field: yatayat.auth.v1.StaffSession session = 1;
   */
  session?: StaffSession | undefined;
};

/**
 * Describes the message yatayat.auth.v1.CompleteStaffSignInResponse.
 * Use `create(CompleteStaffSignInResponseSchema)` to create a new message.
 */
export const CompleteStaffSignInResponseSchema: GenMessage<CompleteStaffSignInResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_auth_v1_auth, 13);

/**
 * @generated from message yatayat.auth.v1.GetStaffSessionRequest
 */
export type GetStaffSessionRequest = Message<"yatayat.auth.v1.GetStaffSessionRequest"> & {
};

/**
 * Describes the message yatayat.auth.v1.GetStaffSessionRequest.
 * Use `create(GetStaffSessionRequestSchema)` to create a new message.
 */
export const GetStaffSessionRequestSchema: GenMessage<GetStaffSessionRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_auth_v1_auth, 14);

/**
 * @generated from message yatayat.auth.v1.GetStaffSessionResponse
 */
export type GetStaffSessionResponse = Message<"yatayat.auth.v1.GetStaffSessionResponse"> & {
  /**
   * Unset when no staff member is signed in.
   *
   * @generated from field: yatayat.auth.v1.StaffSession session = 1;
   */
  session?: StaffSession | undefined;
};

/**
 * Describes the message yatayat.auth.v1.GetStaffSessionResponse.
 * Use `create(GetStaffSessionResponseSchema)` to create a new message.
 */
export const GetStaffSessionResponseSchema: GenMessage<GetStaffSessionResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_auth_v1_auth, 15);

/**
 * @generated from message yatayat.auth.v1.StaffSignOutRequest
 */
export type StaffSignOutRequest = Message<"yatayat.auth.v1.StaffSignOutRequest"> & {
};

/**
 * Describes the message yatayat.auth.v1.StaffSignOutRequest.
 * Use `create(StaffSignOutRequestSchema)` to create a new message.
 */
export const StaffSignOutRequestSchema: GenMessage<StaffSignOutRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_auth_v1_auth, 16);

/**
 * @generated from message yatayat.auth.v1.StaffSignOutResponse
 */
export type StaffSignOutResponse = Message<"yatayat.auth.v1.StaffSignOutResponse"> & {
};

/**
 * Describes the message yatayat.auth.v1.StaffSignOutResponse.
 * Use `create(StaffSignOutResponseSchema)` to create a new message.
 */
export const StaffSignOutResponseSchema: GenMessage<StaffSignOutResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_auth_v1_auth, 17);

/**
 * StaffRole decides which screens and actions a staff member gets.
 *
 * @generated from enum yatayat.auth.v1.StaffRole
 */
export enum StaffRole {
  /**
   * @generated from enum value: STAFF_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Runs an operator's account: every operator screen.
   *
   * @generated from enum value: STAFF_ROLE_OPERATOR_ADMIN = 1;
   */
  OPERATOR_ADMIN = 1,

  /**
   * Sells seats at a counter and sees manifests.
   *
   * @generated from enum value: STAFF_ROLE_COUNTER_CLERK = 2;
   */
  COUNTER_CLERK = 2,

  /**
   * Checks tickets at boarding and sees manifests.
   *
   * @generated from enum value: STAFF_ROLE_CONDUCTOR = 3;
   */
  CONDUCTOR = 3,

  /**
   * Regulator staff of an authority.
   *
   * @generated from enum value: STAFF_ROLE_REGULATOR_ADMIN = 4;
   */
  REGULATOR_ADMIN = 4,

  /**
   * @generated from enum value: STAFF_ROLE_PLANNER = 5;
   */
  PLANNER = 5,

  /**
   * @generated from enum value: STAFF_ROLE_INSPECTOR = 6;
   */
  INSPECTOR = 6,
}

/**
 * Describes the enum yatayat.auth.v1.StaffRole.
 */
export const StaffRoleSchema: GenEnum<StaffRole> = /*@__PURE__*/
  enumDesc(file_yatayat_auth_v1_auth, 0);

/**
 * AuthService signs passengers and staff in with a one-time code sent to their
 * phone (ADR-0014). Each session travels in its own HttpOnly cookie, so one browser
 * can hold a passenger and a staff session at once.
 *
 * @generated from service yatayat.auth.v1.AuthService
 */
export const AuthService: GenService<{
  /**
   * StartPhoneSignIn sends a six-digit code to a Nepali mobile number.
   *
   * @generated from rpc yatayat.auth.v1.AuthService.StartPhoneSignIn
   */
  startPhoneSignIn: {
    methodKind: "unary";
    input: typeof StartPhoneSignInRequestSchema;
    output: typeof StartPhoneSignInResponseSchema;
  },
  /**
   * CompletePhoneSignIn checks the code and starts a session.
   *
   * @generated from rpc yatayat.auth.v1.AuthService.CompletePhoneSignIn
   */
  completePhoneSignIn: {
    methodKind: "unary";
    input: typeof CompletePhoneSignInRequestSchema;
    output: typeof CompletePhoneSignInResponseSchema;
  },
  /**
   * GetSession returns the caller's session, if any.
   *
   * @generated from rpc yatayat.auth.v1.AuthService.GetSession
   */
  getSession: {
    methodKind: "unary";
    input: typeof GetSessionRequestSchema;
    output: typeof GetSessionResponseSchema;
  },
  /**
   * SignOut ends the caller's session.
   *
   * @generated from rpc yatayat.auth.v1.AuthService.SignOut
   */
  signOut: {
    methodKind: "unary";
    input: typeof SignOutRequestSchema;
    output: typeof SignOutResponseSchema;
  },
  /**
   * StartStaffSignIn texts a six-digit code to a registered staff member's phone.
   *
   * @generated from rpc yatayat.auth.v1.AuthService.StartStaffSignIn
   */
  startStaffSignIn: {
    methodKind: "unary";
    input: typeof StartStaffSignInRequestSchema;
    output: typeof StartStaffSignInResponseSchema;
  },
  /**
   * CompleteStaffSignIn checks the code and starts a staff session.
   *
   * @generated from rpc yatayat.auth.v1.AuthService.CompleteStaffSignIn
   */
  completeStaffSignIn: {
    methodKind: "unary";
    input: typeof CompleteStaffSignInRequestSchema;
    output: typeof CompleteStaffSignInResponseSchema;
  },
  /**
   * GetStaffSession returns the signed-in staff member, if any.
   *
   * @generated from rpc yatayat.auth.v1.AuthService.GetStaffSession
   */
  getStaffSession: {
    methodKind: "unary";
    input: typeof GetStaffSessionRequestSchema;
    output: typeof GetStaffSessionResponseSchema;
  },
  /**
   * StaffSignOut ends the caller's staff session.
   *
   * @generated from rpc yatayat.auth.v1.AuthService.StaffSignOut
   */
  staffSignOut: {
    methodKind: "unary";
    input: typeof StaffSignOutRequestSchema;
    output: typeof StaffSignOutResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_yatayat_auth_v1_auth, 0);

